

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function UserAuth() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const navigate = useNavigate();

  
  const handleLogin = async (e) => {
  e.preventDefault();
  if (!email || !password) {
    setError('Please enter both email and password');
    return;
  }

  setLoading(true);
  try {
    const response = await axios.post('https://firstaidba.vercel.app/api/user/login', { 
      email, 
      password 
    });
    
   
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      setError('');
      navigate('/user-dashboard'); 
    } else {
      setError(response.data.message || 'Login failed');
    }
  } catch (err) {
    console.error('Error logging in:', err);
    setError(err.response?.data?.message || 'Login failed');
  } finally {
    setLoading(false);
  }
};

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!email || !phone || !password || !passwordConfirmation) {
      setError('Please fill all fields');
      return;
    }

    if (password !== passwordConfirmation) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('https://firstaidba.vercel.app/api/user/register', {
        email,
        phone,
        password,
        passwordConfirmation
      });
      
      if (response.status === 201) {
        setError('');
        setShowSignupModal(false);
        // Optionally auto-login after signup
        // await handleLogin(e);
        alert('Registration successful! Please login.');
      }
    } catch (err) {
      console.error('Error signing up:', err);
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-center mb-6">
          <svg className="w-16 h-16 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-center text-purple-700 mb-6">
          {isLogin ? 'User Login' : 'Create Account'}
        </h2>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        
        {isLogin ? (
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Enter your email"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Enter your password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition disabled:bg-purple-400"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
            
            <div className="mt-4 text-center">
              <p className="text-gray-600">
                Don't have an account?{' '}
                <button
                  type="button"
                  onClick={() => setIsLogin(false)}
                  className="text-purple-600 hover:underline"
                >
                  Sign up
                </button>
              </p>
            </div>
          </form>
        ) : (
          <form onSubmit={handleSignup}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Phone Number</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Enter your phone number"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Create a password"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Confirm Password</label>
              <input
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
                placeholder="Confirm your password"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition disabled:bg-purple-400"
            >
              {loading ? 'Creating account...' : 'Sign Up'}
            </button>
            
            <div className="mt-4 text-center">
              <p className="text-gray-600">
                Already have an account?{' '}
                <button
                  type="button"
                  onClick={() => setIsLogin(true)}
                  className="text-purple-600 hover:underline"
                >
                  Login
                </button>
              </p>
            </div>
          </form>
        )}
        
        <button
          onClick={() => navigate('/')}
          className="w-full text-purple-600 mt-4 text-center hover:underline"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default UserAuth;